import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, CheckCircle, Phone } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { services, contactInfo } from '../mockData';

const ServiceDetail = () => {
  const { serviceId } = useParams();
  const service = services.find(s => s.id === serviceId);

  if (!service) {
    return (
      <div className="min-h-screen bg-black pt-24 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-white mb-4">Hizmet Bulunamadı</h1>
          <Link to="/hizmetler">
            <Button className="bg-yellow-500 text-black hover:bg-yellow-600">
              Hizmetlere Dön
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black pt-24">
      <section className="section-padding">
        <div className="container-custom">
          <div className="mb-8">
            <Link to="/hizmetler" className="inline-flex items-center text-yellow-500 hover:text-yellow-400">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Tüm Hizmetler
            </Link>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
            <div>
              <div className="rounded-2xl overflow-hidden mb-6">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-96 object-cover"
                />
              </div>
            </div>

            <div className="space-y-6">
              <h1 className="text-4xl md:text-5xl font-bold text-gradient-gold">
                {service.title}
              </h1>
              <p className="text-xl text-gray-300 leading-relaxed">
                {service.description}
              </p>

              <Card className="bg-zinc-900 border-zinc-800">
                <CardContent className="pt-6">
                  <h3 className="text-xl font-bold text-white mb-4">Hizmet Özellikleri</h3>
                  <ul className="space-y-3">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-start space-x-3">
                        <CheckCircle className="w-5 h-5 text-yellow-500 mt-0.5 flex-shrink-0" />
                        <span className="text-gray-300">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>

              <div className="bg-gradient-to-r from-zinc-900 to-zinc-800 rounded-xl p-6 space-y-4">
                <h3 className="text-xl font-bold text-white">Hemen Teklif Alın</h3>
                <p className="text-gray-300">Profesyonel ekibimiz size en uygun çözümü sunmak için hazır</p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <a href={`tel:${contactInfo.phones[0].number.replace(/\s/g, '')}`} className="flex-1">
                    <Button className="w-full bg-yellow-500 text-black hover:bg-yellow-600">
                      <Phone className="w-4 h-4 mr-2" />
                      Hemen Ara
                    </Button>
                  </a>
                  <a href={`https://wa.me/${contactInfo.whatsapp}`} target="_blank" rel="noopener noreferrer" className="flex-1">
                    <Button variant="outline" className="w-full border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black">
                      WhatsApp
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-zinc-950 rounded-2xl p-8 md:p-12">
            <h2 className="text-3xl font-bold text-gradient-gold mb-6 text-center">
              Neden Bizi Seçmelisiniz?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { title: 'Profesyonel Ekipman', desc: 'En son teknoloji cihazlar' },
                { title: 'Deneyimli Kadro', desc: 'Yılların tecrübesi' },
                { title: 'Hızlı Çözüm', desc: 'Aynı gün hizmet' },
                { title: 'Uygun Fiyat', desc: 'Şeffaf fiyatlandırma' }
              ].map((item, index) => (
                <div key={index} className="text-center space-y-2">
                  <div className="w-12 h-12 mx-auto bg-yellow-500/10 rounded-full flex items-center justify-center border-2 border-yellow-500/30">
                    <CheckCircle className="w-6 h-6 text-yellow-500" />
                  </div>
                  <h4 className="font-bold text-white">{item.title}</h4>
                  <p className="text-sm text-gray-400">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceDetail;
